// @ts-check
import React from 'react';
import classes from './Show/ReferralsShow.module.scss';
import Icon from 'shared/components/Icon';
import ToothSelector from '../ToothSelector';
import { SignaturePad } from '../SignaturePad';

const AnswersForQuestion = ({ question }) => {
  if (question.elementType === 'tooth_selector') {
    return <ToothSelector value={question.answers} readOnly />;
  }
  if (question.elementType === 'signature') {
    return <SignaturePad value={question.answer} editable={false} />;
  }
  if (question.answers && question.answers.length > 0) {
    return (
      <ul>
        {question.answers.map(answer => (
          <li key={answer}>{answer}</li>
        ))}
      </ul>
    );
  } else if (question.answer) {
    return <p>{question.answer}</p>;
  } else {
    return <p>Not available</p>;
  }
};

const componentForQuestion = question => {
  if (question.elementType === 'signature') {
    return (
      <div className="max-w-3xl mx-auto px-2">
        <p style={{ whiteSpace: 'pre-wrap' }} className="py-8">
          {question.prompt}
        </p>
        <div>
          <AnswersForQuestion question={question} />
        </div>
      </div>
    );
  }
  return (
    <div className={classes.question_container}>
      <div className={classes.question_prompt}>{question.prompt}</div>
      <div className={classes.question_answer}>
        <AnswersForQuestion question={question} />
      </div>
    </div>
  );
};

const ReferralQuestionnaire = ({ pdfUrl, questionnaire }) => (
  <div className={classes.section}>
    <h3 className={classes.section_header}>Referral Questionnaire Answers</h3>
    {pdfUrl ? (
      <div>
        <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
          <Icon name="printer" /> Print
        </a>
        &nbsp;&nbsp;
        <a href={`${pdfUrl}?disposition=attachment`}>
          <Icon name="file-pdf" /> Download
        </a>
      </div>
    ) : null}
    <div className={classes.section_content}>
      <div>
        {questionnaire.sections.map(section => (
          <div key={section.title}>
            <div style={{ marginBottom: '17px' }} className={classes.questionnaire_section_title}>
              <span style={{ textDecoration: 'underline' }}>{section.title}</span>
            </div>

            {section.questions.map((question, idx) => (
              <div key={idx}>{componentForQuestion(question)}</div>
            ))}
            <div className={classes.question_container}>
              <div className={classes.question_prompt}>Notes:</div>
              <div className={classes.question_answer}>{section.notes}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ReferralQuestionnaire;
